import { EntityShareActions } from "stores/permissions/EntityShareStore";
import notifyingAction from "../notifyingAction";
const prepare = notifyingAction({
  action: EntityShareActions.prepare,
  error: (error, entityType, entityName) => ({
    message: `Preparing shares for ${entityType} "${entityName}" failed with status: ${error}`
  })
});
const update = notifyingAction({
  action: EntityShareActions.update,
  error: (error, entityType, entityName) => ({
    message: `Updating shares for ${entityType} "${entityName}" failed with status: ${error}`
  }),
  success: (entityType, entityName) => ({
    message: `Shares for ${entityType} "${entityName}" updated successfully`
  })
});
const loadUserSharesPaginated = notifyingAction({
  action: EntityShareActions.loadUserSharesPaginated,
  error: (error, userId) => ({
    message: `Loading entities which got shared for user with id "${userId}" failed with status: ${error}`
  })
});
export default {
  prepare,
  update,
  loadUserSharesPaginated
};
